import { render, staticRenderFns } from "./EducationDetailsTabs.vue?vue&type=template&id=332d6b50"
import script from "./EducationDetailsTabs.vue?vue&type=script&lang=js"
export * from "./EducationDetailsTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports